import { Box, IconButton, Badge, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setOverlayVisible } from "../../redux/actions/overlay";
import BurgerMenu from "../menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Logo from "../../assets/mindstack-logo.png";
import useWindowDimensions from "../../helpers/window";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeUser } = useSelector((state) => state.user);
  const messages = useSelector((state) => state.messages);
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  const onLogoClicked = () => {
    dispatch(setOverlayVisible({ visible: false }));
  };

  const unreadCount = messages?.reduce((count, msg) => {
    // Only count unread messages from admin (not user's own messages)
    const isFromAdmin =
      msg.senderType === "admin" || !msg.senderType || msg.sentTo === "global";
    return count + (!msg.read && isFromAdmin ? 1 : 0);
  }, 0);

  return (
    <div className="header">
      <BurgerMenu />
      <Link
        to={isMobile ? "/dashboard" : "/"}
        onClick={onLogoClicked}
        className="header_logo-container"
      >
        <img className="header_logo-image" src={Logo} alt="Mindstack Logo" />
        <Typography variant="headerTitle">Mindstack</Typography>
      </Link>
      <div>
        {activeUser && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              component={Link}
              to="/dashboard"
              className="header_icon-button"
              sx={{ mr: { xs: "8px", md: "16px" } }}
            >
              <DashboardIcon className="header_icon-button-icon" />
            </IconButton>
            <IconButton
              component={Link}
              to="/about/what-is-mindstack"
              className="header_icon-button"
              sx={{ mr: { xs: "8px", md: "16px" } }}
            >
              <HelpOutlineIcon className="header_icon-button-icon" />
            </IconButton>
            <IconButton
              onClick={() => {
                dispatch(
                  setOverlayVisible({ overlayType: "messages", visible: true }),
                );
              }}
              className="header_icon-button"
            >
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon className="header_icon-button-icon" />
              </Badge>
            </IconButton>
            <IconButton
              onClick={() => navigate("/account")}
              className="header_icon-button"
              sx={{ ml: { xs: "8px", md: "16px" } }}
            >
              <AccountCircleIcon className="header_icon-button-icon" />
            </IconButton>
          </Box>
        )}
      </div>
    </div>
  );
};

export default Header;
